import "./VisasForGroupsAndSchoolTrips.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TherapeutischeSchwerpunkte from "./sections/TherapeutischeSchwerpunkte";
import KnowledgeBase from "./sections/KnowledgeBase";
import RichiediAssistenza from "./sections/RichiediAssistenza";
import Footer from "@/reusable_sections/Footer";
export default function VisasForGroupsAndSchoolTripsPage() {
  return <div>
      <Header />
      <Hero />
      <TherapeutischeSchwerpunkte />
      <KnowledgeBase />
      <RichiediAssistenza />
      <Footer />
    </div>;
}